import { useScrollReveal } from "@/hooks/useScrollReveal";
import type { ReactNode } from "react";

export default function Reveal({ children, delay = 0 }: { children: ReactNode; delay?: number }) {
  const { ref, revealed } = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${
        revealed
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-6"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}